/* eslint-disable max-lines, sort-imports */
import {
  CLEAR_TRANSPORT_DATES,
  CLEAR_TRANSPORT_LOCATIONS,
  CLEAR_TRANSPORT_STOPS,
  GET_ACCOMMODATION_EXTRAS,
  GET_ACCOMMODATION_EXTRAS_SUCCESS,
  GET_ACCOMMODATIONS,
  GET_ACCOMMODATIONS_AVAILABILITY,
  GET_ACCOMMODATIONS_AVAILABILITY_SUCCESS,
  GET_ACCOMMODATIONS_SUCCESS,
  GET_EXTRA_AVAILABILITY,
  GET_EXTRA_AVAILABILITY_SUCCESS,
  GET_EXTRAS,
  GET_EXTRAS_AVAILABILITY,
  GET_EXTRAS_AVAILABILITY_SUCCESS,
  GET_EXTRAS_SUCCESS,
  GET_TERMS_CONDITIONS,
  GET_TERMS_CONDITIONS_FAILED,
  GET_TERMS_CONDITIONS_SUCCESS,
  GET_TICKETS,
  GET_TICKETS_AVAILABILITY,
  GET_TICKETS_AVAILABILITY_SUCCESS,
  GET_TICKETS_SUCCESS,
  GET_TRANSPORT_DATES,
  GET_TRANSPORT_DATES_SUCCESS,
  GET_TRANSPORT_LOCATIONS,
  GET_TRANSPORT_LOCATIONS_SUCCESS,
  GET_TRANSPORT_OUTBOUND_STOPS,
  GET_TRANSPORT_OUTBOUND_STOPS_SUCCESS,
  GET_TRANSPORT_RETURN_STOPS,
  GET_TRANSPORT_RETURN_STOPS_SUCCESS,
  GET_TRANSPORT_ROUTES,
  GET_TRANSPORT_ROUTES_SUCCESS,
  GET_TRANSPORT_STOPS,
  GET_TRANSPORT_STOPS_SUCCESS,
  GET_TRANSPORT_TYPES,
  GET_TRANSPORT_TYPES_SUCCESS,
} from './types';

export const getAccommodations = bookingRef => ({
  type: GET_ACCOMMODATIONS,
  payload: { bookingRef },
});

export const getAccommodationsSuccess = (bookingRef, accommodations) => ({
  type: GET_ACCOMMODATIONS_SUCCESS,
  payload: { bookingRef, accommodations },
});

export const getAccommodationsAvailability = bookingRef => ({
  type: GET_ACCOMMODATIONS_AVAILABILITY,
  payload: { bookingRef },
});

export const getAccommodationsAvailabilitySuccess = (
  bookingRef,
  availability,
) => ({
  type: GET_ACCOMMODATIONS_AVAILABILITY_SUCCESS,
  payload: { bookingRef, availability },
});

export const getExtras = bookingRef => ({
  type: GET_EXTRAS,
  payload: { bookingRef },
});

export const getExtrasSuccess = (bookingRef, extras) => ({
  type: GET_EXTRAS_SUCCESS,
  payload: { bookingRef, extras },
});

export const getAccommodationExtras = (bookingRef, accommodationId) => ({
  type: GET_ACCOMMODATION_EXTRAS,
  payload: { bookingRef, accommodationId },
});

export const getAccommodationExtrasSuccess = (
  bookingRef,
  accommodationId,
  accommodationExtras,
) => ({
  type: GET_ACCOMMODATION_EXTRAS_SUCCESS,
  payload: { bookingRef, accommodationId, accommodationExtras },
});

export const getTransportTypes = bookingRef => ({
  type: GET_TRANSPORT_TYPES,
  payload: {
    bookingRef,
  },
});

export const getTransportTypesSuccess = (bookingRef, transportTypes) => ({
  type: GET_TRANSPORT_TYPES_SUCCESS,
  payload: {
    bookingRef,
    transportTypes,
  },
});

export const getTransportLocations = (
  bookingRef,
  routeIds,
  date,
  direction,
) => ({
  type: GET_TRANSPORT_LOCATIONS,
  payload: {
    bookingRef,
    routeIds,
    date,
    direction,
  },
});

export const clearTransportLocations = bookingRef => ({
  type: CLEAR_TRANSPORT_LOCATIONS,
  payload: {
    bookingRef,
  },
});

export const getTransportLocationsSuccess = (
  bookingRef,
  transportLocations,
) => ({
  type: GET_TRANSPORT_LOCATIONS_SUCCESS,
  payload: {
    bookingRef,
    transportLocations,
  },
});

export const getTransportStops = (
  bookingRef,
  routeIds,
  date,
  departureLocation,
  arrivalLocation,
) => ({
  type: GET_TRANSPORT_STOPS,
  payload: {
    bookingRef,
    routeIds,
    date,
    departureLocation,
    arrivalLocation,
  },
});

export const getTransportOutboundStops = (
  bookingRef,
  routeIds,
  date,
  departureLocation,
  arrivalLocation,
) => ({
  type: GET_TRANSPORT_OUTBOUND_STOPS,
  payload: {
    bookingRef,
    routeIds,
    date,
    departureLocation,
    arrivalLocation,
  },
});

export const getTransportReturnStops = (
  bookingRef,
  routeIds,
  date,
  departureLocation,
  arrivalLocation,
) => ({
  type: GET_TRANSPORT_RETURN_STOPS,
  payload: {
    bookingRef,
    routeIds,
    date,
    departureLocation,
    arrivalLocation,
  },
});

export const clearTransportStops = bookingRef => ({
  type: CLEAR_TRANSPORT_STOPS,
  payload: {
    bookingRef,
  },
});

export const getTransportStopsSuccess = (
  bookingRef,
  outboundStops,
  returnStops,
) => ({
  type: GET_TRANSPORT_STOPS_SUCCESS,
  payload: {
    bookingRef,
    outboundStops,
    returnStops,
  },
});

export const getTransportOutboundStopsSuccess = (
  bookingRef,
  outboundStops,
) => ({
  type: GET_TRANSPORT_OUTBOUND_STOPS_SUCCESS,
  payload: {
    bookingRef,
    outboundStops,
  },
});

export const getTransportReturnStopsSuccess = (bookingRef, returnStops) => ({
  type: GET_TRANSPORT_RETURN_STOPS_SUCCESS,
  payload: {
    bookingRef,
    returnStops,
  },
});

export const getTransportDates = (bookingRef, routeIds, direction) => ({
  type: GET_TRANSPORT_DATES,
  payload: {
    bookingRef,
    routeIds,
    direction,
  },
});

export const clearTransportDates = bookingRef => ({
  type: CLEAR_TRANSPORT_DATES,
  payload: {
    bookingRef,
  },
});

export const getTransportDatesSuccess = (bookingRef, transportDates) => ({
  type: GET_TRANSPORT_DATES_SUCCESS,
  payload: {
    bookingRef,
    transportDates,
  },
});

export const getTransportRoutes = bookingRef => ({
  type: GET_TRANSPORT_ROUTES,
  payload: {
    bookingRef,
  },
});

export const getTransportRoutesSuccess = (bookingRef, transportRoutes) => ({
  type: GET_TRANSPORT_ROUTES_SUCCESS,
  payload: {
    bookingRef,
    transportRoutes,
  },
});

export const getExtrasAvailability = bookingRef => ({
  type: GET_EXTRAS_AVAILABILITY,
  payload: { bookingRef },
});

export const getExtrasAvailabilitySuccess = (bookingRef, availability) => ({
  type: GET_EXTRAS_AVAILABILITY_SUCCESS,
  payload: { bookingRef, availability },
});

export const getExtraAvailability = (bookingRef, extraId) => ({
  type: GET_EXTRA_AVAILABILITY,
  payload: { bookingRef, extraId },
});

export const getExtraAvailabilitySuccess = (bookingRef, availability) => ({
  type: GET_EXTRA_AVAILABILITY_SUCCESS,
  payload: { bookingRef, availability },
});

export const getTickets = bookingRef => ({
  type: GET_TICKETS,
  payload: { bookingRef },
});

export const getTicketsSuccess = (bookingRef, events) => ({
  type: GET_TICKETS_SUCCESS,
  payload: { bookingRef, events },
});

export const getTicketsAvailability = bookingRef => ({
  type: GET_TICKETS_AVAILABILITY,
  payload: { bookingRef },
});

export const getTicketsAvailabilitySuccess = (bookingRef, tickets) => ({
  type: GET_TICKETS_AVAILABILITY_SUCCESS,
  payload: { bookingRef, tickets },
});

export const getTermsConditions = bookingRef => ({
  type: GET_TERMS_CONDITIONS,
  payload: { bookingRef },
});

export const getTermsConditionsSuccess = (bookingRef, termsConditions) => ({
  type: GET_TERMS_CONDITIONS_SUCCESS,
  payload: { bookingRef, termsConditions },
});

export const getTermsConditionsFailed = (bookingRef, error = null) => ({
  type: GET_TERMS_CONDITIONS_FAILED,
  payload: { bookingRef, error },
});
